import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { SERVICES } from "../data/services";

export const Footer = () => {
  const featured = SERVICES.slice(0, 6);
  const more = SERVICES.slice(6, 12);
  const year = new Date().getFullYear();
  return (
    <footer className="nnc-bg text-white mt-24" data-testid="site-footer">
      <div className="h-[3px] w-full nnc-gold-bg" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Brand block */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src="/assets/nnc-logo.svg"
                alt="NNC Medallion"
                className="h-14 w-14"
                data-testid="footer-logo"
              />
              <div>
                <div className="font-bold text-base leading-tight text-white">
                  Nonprofit Navigation
                </div>
                <div className="font-bold text-base leading-tight text-white">
                  Consulting, LLC
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-white/80 max-w-sm">
              Guiding mission-driven impact. Consulting for nonprofits, public
              agencies, government contractors, and community builders —
              across our region, the country, and into Canada.
            </p>
            <div
              className="mt-6 inline-flex items-center gap-2 text-sm text-white"
              data-testid="footer-location"
            >
              <MapPin className="h-4 w-4 nnc-gold-text" strokeWidth={2.5} />
              <span className="font-bold tracking-wide">
                Morgantown, West Virginia
              </span>
            </div>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <div className="nnc-overline mb-4">Practice Areas</div>
            <ul className="space-y-2">
              {featured.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-sm text-white/85 hover:text-[#FCB814] transition-colors"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More services */}
          <div className="lg:col-span-3">
            <div className="nnc-overline mb-4 invisible lg:visible">More</div>
            <ul className="space-y-2">
              {more.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-sm text-white/85 hover:text-[#FCB814] transition-colors"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/services"
              className="inline-block mt-4 text-xs font-bold uppercase tracking-widest nnc-gold-text hover:underline"
              data-testid="footer-view-all-services"
            >
              View All {SERVICES.length} →
            </Link>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-2">
            <div className="nnc-overline mb-4">Navigate</div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-white/85 hover:text-[#FCB814] transition-colors"
                  data-testid="footer-link-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/85 hover:text-[#FCB814] transition-colors"
                  data-testid="footer-link-about"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm text-white/85 hover:text-[#FCB814] transition-colors"
                  data-testid="footer-link-services"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-white/85 hover:text-[#FCB814] transition-colors"
                  data-testid="footer-link-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/70" data-testid="footer-copyright">
            © {year} Nonprofit Navigation Consulting, LLC. All rights reserved.
          </p>
          <p className="text-xs nnc-gold-text font-bold tracking-[0.25em] uppercase">
            Guiding · Mission · Driven · Impact
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
